import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StatusPillType } from '../../../pills/general-status-pill/status-pill-type.enum';
import { GeneralStatusPillComponent } from '../../../pills/general-status-pill/general-status-pill.component';
import { LoadingShimmerComponent } from '../../../loading-shimmer/loading-shimmer.component';

@Component({
  selector: 'lib-status-pill-cell',
  imports: [GeneralStatusPillComponent, LoadingShimmerComponent],
  templateUrl: './status-pill-cell.component.html',
  styleUrl: './status-pill-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusPillCellComponent {
  type = input.required<StatusPillType>();
  text = input.required<string>();
  loading = input.required<boolean>();
  placeholder = input<string>('–');
}
